import { useTranslation } from 'react-i18next'

import { faDigits } from '../../lib/numerals'
import { triesShown } from '../../lib/transcriptLock'

/**
 * The lesson's text while it is still closed (owner rule, the Android app's
 * LockedCard): a lock, a dot per try and «۱/۳». No sentences on the page
 * (owner, 2026-10-14: «جملات اضافه و توضیحی نمیخوام») — what the lock means
 * is said to a screen reader only.
 */
export function LockedTranscript({ lock }) {
  const { t } = useTranslation('lesson')
  const shown = triesShown(lock)
  const label = `${t('lock.title')} — ${t('lock.tries', { n: faDigits(shown), total: faDigits(lock.unlockAfter) })}`
  return (
    <div data-transcript-lock="locked" role="img" aria-label={label} className="flex items-center justify-center gap-3 rounded-2xl bg-surface-2 px-4 py-3 ring-1 ring-line">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" className="text-ink-3">
        <rect x="5" y="11" width="14" height="10" rx="2" />
        <path d="M8 11V7a4 4 0 0 1 8 0v4" />
      </svg>
      <span className="flex gap-1" aria-hidden="true">
        {Array.from({ length: lock.unlockAfter }, (_, i) => (
          <span key={i} data-try-dot={i < shown ? 'failed' : 'todo'} className={`size-2 rounded-full ${i < shown ? 'bg-warn' : 'bg-line'}`} />
        ))}
      </span>
      <span dir="ltr" aria-hidden="true" className="tnum text-xs font-semibold text-ink-2">
        {faDigits(shown)}/{faDigits(lock.unlockAfter)}
      </span>
    </div>
  )
}
